/* global define:true, document:true, window: true */

/*
 * This instantiates a Backbone view instance that sets timers to prompt user
 * to extend their session after 14 minute time limit. If they do not extend
 * the session, there will be an automatic fullpage redirect to a page showing
 * a message that relogin in is required
 *
 * To test: use a bookmarklet to add buttons to the DOM which will trigger
 * messages for confirm session, expired session, and ajax error:
 *
 *		javascript:(function(){var $sessionBtns=$('<p><center><button
 *		type="button" class="btn btn-secondary"
 *		data-trigger="testSessionMessageConfirm">Confirm Message</button>
 *		<button type="button" class="btn btn-secondary"
 *		data-trigger="testSessionMessageError">Error
 *		Message</button></center></p>');$sessionBtns.insertBefore('h1');})();
 *
 * The listener for clicking an element with `data-trigger="extendSession` allow
 * the extendSession method to be testable.
 *
 * Author: Tim Sullivan
 */

define([
	'jquery',
	'underscore',
	'BaseView',
	'backbone',
	'widgets/theoverpanel',
	'neff'
], function ($, _, BaseView, Backbone, overpanelView, neff) {

	'use strict';

	// a view for interactions
	var SessionTimerView = BaseView.extend({
		el: '#overpanel',

		template: 'widgets/confirmSession',

		confirmationTimer: null,
		confirmationTimerLimit: 14 * 60 * 1000, // 14 minutes in millisecs
		expirationTimer: null,
		expirationTimerLimit: 15 * 60 * 1000, // 15 minutes in millisecs
		loginRedirectPath: '/signout', // A full page load
		extendSessionUrl: function () {
			// An AJAX endpoint giving an empty object JSON response upon success.
			return this.model.get('extendSessionUrl');
		},

		events: {
			'click .reLogIn': 'reLogIn',
			'click .extendSession': function (event) {
				overpanelView.hideOverpanel();
				this.extendSession(event);
			}
		},

		initialize: function (options) {
			// disable template's close button
			var extendSessionUrl = (options && options.extendSessionUrl) || '/myaccount/extendSession';

			this.model = new Backbone.Model({
				hideClose: true,
				extendSessionUrl: extendSessionUrl
			});

			// start the countdown clock
			this.initializeTimers();

			// extend session before starting a flow that ends with AJAX request
			$('[data-trigger="extendSession"]').click(
				$.proxy(this.extendSession, this, { isTrigger: true })
			);

			if (neff.isEnabled('test-session-messages')) {
				// This is used for functional testing
				// Manually displays the "are you still there" message.
				$('#contents').on('click', '[data-trigger="testSessionMessageConfirm"]',
					$.proxy(this.confirmSession, this, true)
				);
			}

			// event listener to reset timers upon ajax call
			$(document).ajaxSuccess($.proxy(this.initializeTimers, this));
		},

		initializeTimers: function () {
			// Reset timers. OK if the timer ID is null
			window.clearTimeout(this.confirmationTimer);
			window.clearTimeout(this.expirationTimer);

			// Add 14 minute timer to allow the user to rescue the session before it expires
			this.confirmationTimer = window.setTimeout($.proxy(function () {
				// "true" param gives the extend session experience
				Backbone.trigger('sessionTimer:sessionTimedOut');
				this.confirmSession();
			}, this), this.confirmationTimerLimit);

			// Add 15 minute timer to redirect user to login screen,
			// so that sensitive information is no longer viewable in the source
			this.expirationTimer = window.setTimeout($.proxy(function () {
				window.location = this.loginRedirectPath;
			}, this), this.expirationTimerLimit);
		},

		/**
		 * Event handler for clicking 'Keep me logged in' when user is prompted
		 * whether they want to stay logged in.
		 *
		 * @param e - click event or static object
		 *
		 * This method can be called statically. See view/activity/transactionView
		 *
		 * When called statically, instead of jQuery passing a click event
		 * object, the Dev must pass { isTrigger: true }
		 */
		extendSession: function (event) {
			// Ajax call to extend session
			$.ajax({
				url: this.extendSessionUrl(),
				context: this,
				success: function () {
					// close overpanel
					overpanelView.hideOverpanel();

					// reset timers
					this.initializeTimers();
				},
				dataType: 'json'
			});

			if (!event.isTrigger) {
				event.stopPropagation();
				return false;
			}
		},

		confirmSession: function () {
			// break Esc key, only way to dismiss is through primary action button
			overpanelView.canUseEsc = false;

			// present overpanel
			overpanelView.setContent(this); // automatically causes this view to render and overpanel to show
		}

	});

	return SessionTimerView;
});



//////////////////
// WEBPACK FOOTER
// ./widgets/sessionTimer.js
// module id = 764
// module chunks = 0